import React, { useContext } from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import { useStyles } from "../../styles";
import { icons } from "../../../../../../../../../../utils/icons";
import { useTranslation } from "react-i18next";
import { Status } from "../../../../../../../../../../utils/enums";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { NavigatioStateType } from '../../../../../../../../../../utils/enums/navigatetionState';
import StatusComponent from '../../../../../../../../../../components/status';
import { getStatus } from '../../../../../../../../../../hooks/status';
import { GlobalContext } from '../../../../../../../../../../contexts/Global';

export const Questionnary = ({ data, historial }) => {
  const styles = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xl"));
   const { colors } = useContext(GlobalContext)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const Questionnaire = historial?.assingQuestionnaire;
  const isWaitingResponse = Questionnaire?.statusId === Status.TO_BE_STARTED || Questionnaire?.statusId != Status.FINISHED;
  const unity = historial?.storeName.toUpperCase();
  const status = getStatus(Questionnaire?.statusId as Status, colors, t)

  const formatDateRequest = Questionnaire?.dateStart
    ? format(new Date(Questionnaire.dateStart), "dd/MM/yyyy HH:mm", { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const handleViewDetail = () => {
    const questionnaireId = Questionnaire.scheduledVisitId;
    const baseUrl = `/dashboard/calendar/detail/${questionnaireId}`;

    const url = id ? `${baseUrl}?idFolio=${id}` : baseUrl;

    navigate(url, {
      state: {
        type: NavigatioStateType.USER_SCHEDULE,
        id: questionnaireId
      }
    });
  };

  const formatDateSolveCuestionarie = Questionnaire?.dateFinishAnswer
    ? format(new Date(Questionnaire.dateFinishAnswer), "dd/MM/yyyy HH:mm", { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  return (
    <Box>
      <Box display="flex" /* justifyContent="space-between" */ gap={1} alignItems="center">
        {isWaitingResponse ? (
          <>
            <Box display="flex" alignItems="center">
              <Typography sx={styles.title(5)}>
                {icons("Watch")}
              </Typography>
              <Typography style={{ marginLeft: '8px' }} sx={styles.title(5)}>
                {Questionnaire?.questionnaireMainData?.name}
              </Typography>
            </Box>
          </>
        ) : (
          <Box display="flex" alignItems="center">
            <Typography sx={styles.title(4)}>
              {icons("check-simple")}
            </Typography>
            <Typography style={{ marginLeft: '8px' }} sx={styles.title(5)}>
              {Questionnaire?.questionnaireMainData?.name}
            </Typography>
          </Box>
        )}
        <StatusComponent color={status.color} msg={status.text} type='chip' fit size='xs' />
      </Box>

      <Box>
        {isWaitingResponse ? (
          <>
            <Typography variant={isSmallScreen ? "body2" : "body1"}>
              {t("reportFolio.detail.general.isWaitingResponseCuestionarie", {
                Id: Questionnaire?.id,
                version: Questionnaire?.questionnaireMainData.version,
                Date: formatDateRequest,
                unidad: unity
              })}
            </Typography>
            <Typography variant="body2">
              {t("reportFolio.detail.general.pleaseCompleteCuestionarie")}
            </Typography>
          </>

        ) : (
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography variant={isSmallScreen ? "body2" : "body1"}>
              {t("reportFolio.detail.general.isWaitingResponseCuestionarieCompleted", {
                Id: Questionnaire.id,
                version: Questionnaire?.questionnaireMainData.version,
                Date: formatDateRequest,
                unidad: unity,
                DateSolve: formatDateSolveCuestionarie
              })}
            </Typography>
            <Box>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleViewDetail}
              >
                {t("reportFolio.detail.general.seeDetail")}
              </Button>
            </Box>

          </Box>
        )}

      </Box>
    </Box>
  );
};
